export enum SalesOrderListTabsEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  TEMPLATE = 'template',
  ALL = 'all',
}
